import { PropsWithChildren } from 'react';

type Props = PropsWithChildren;

export function Head({ children }: Props) {
  return <thead>{children}</thead>;
}
